import { computed, ref, reactive, watch } from "vue";
import Utilities from "src/composables/Utilities";
import { Info } from "luxon";
import { useSessionStorage } from "vue-composable";
import Analytics from "src/composables/Analytics";

const { log_event } = Analytics();

const { distinct } = Utilities()
const historical_usage_changed = ref(false);
const is_live_link_usage = ref(false)
const show_live_link_info = ref(true)

const { storage: usage_type } = useSessionStorage('usage_type', 'kWh');
const { storage: usage_selected } = useSessionStorage('usage_selected', 1000);
const { storage: custom_usage_amount } = useSessionStorage('custom_usage_amount', null);
const { storage: historical_usage } = useSessionStorage('historical_usage', Info.months("long").map(x => {
    return {
      month: x,
      usage: null,
      short_month: x.substring(0, 3)
    };
  })
);
const valid_historical_usage = computed(() => historical_usage.value && historical_usage.value.filter(x => x.usage))
const historical_usage_count = computed(() => valid_historical_usage.value.length);
const show_historical_usage = computed(() => usage_type.value === 'historical' && historical_usage_count.value > 0)
const historical_usage_values = computed(() => {
  if (show_historical_usage.value) {
    return valid_historical_usage.value.map(x => x.usage).filter(distinct)
  }
})

const standard_usage_profile = [
  1.05,
  0.93,
  0.93,
  0.71,
  0.81,
  1.1,
  1.32,
  1.38,
  1.27,
  0.96,
  0.74,
  0.8
]

const usage_profile = computed(() => standard_usage_profile.map(x => Math.round(x * usage_selected.value)))

watch(usage_selected, () => {
  log_event({
    name: 'shop_usage_selected',
    cp_shop: {
      usage: parseInt(usage_selected.value)
    }
  })
})

const clear = () => {
  usage_type.value = 'kWh'
  historical_usage.value = Info.months("long").map(x => {
    return {
      month: x,
      usage: null,
      short_month: x.substring(0, 3)
    };
  });
  usage_selected.value = 1000;
  custom_usage_amount.value = null;
}

export default () => {

  return {
    show_live_link_info,
    is_live_link_usage,
    usage_type,

    usage_selected,
    usage_profile,

    custom_usage_amount,

    historical_usage,
    historical_usage_changed,
    show_historical_usage,
    valid_historical_usage,
    historical_usage_count,
    historical_usage_values,
    clear
  }
}

